import { mainApi } from '../../../../../api/mainApi';
import { middlewareApi } from '../../../../middleware/middlewareApi';
import { AnnouncementCourse, AnnouncementPayload } from '../interfaces/announcement.interfaces';
import { AccessState, AuthState } from '../../../../../types';

export const announcementTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['AnnouncementsTag'],
});
// Define a service using a base URL and expected endpoints
export const announcementTeacherApi = announcementTags.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * @GET get list announce by course
     */
    getAnnouncementsByCourseTeacher: builder.query<
      AnnouncementCourse[],
      {
        acronym?: string;
        courseId: number;
      }
    >({
      queryFn: async ({ courseId, acronym = 'ANU' }, { dispatch, getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          // const {
          //   virtualClassroomTeacher: { course },
          // } = getState() as { virtualClassroomTeacher: EvaluationState };

          const user_profile_id = currentProfile?.profileId;
          // const courseId = course?.courseId;

          const { data } = await mainApi.get<AnnouncementCourse[]>(`/users/announcements`, {
            params: {
              user_profile_id,
              acronym,
              course: courseId,
            },
          });

          return { data: Array.isArray(data) ? data : [] };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'AnnouncementsTag', id } as const)),
              { type: 'AnnouncementsTag', id: 'LIST' },
            ]
          : [{ type: 'AnnouncementsTag', id: 'LIST' }],
    }),

    /**
     * @POST create announcement
     */
    addAnnouncement: builder.mutation<
      AnnouncementPayload,
      { courseId: number; acronym?: string; announcementdPayload: Partial<AnnouncementPayload> }
    >({
      queryFn: async ({ courseId, announcementdPayload, acronym = 'ANU' }, { getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const {
            auth: { userInfo },
          } = getState() as { auth: AuthState };

          // const {
          //   virtualClassroomTeacher: { course },
          // } = getState() as { virtualClassroomTeacher: EvaluationState };

          const { data } = await mainApi.post<AnnouncementPayload>('/users/ads', {
            user_profile_id: currentProfile?.profileId,
            user_id: userInfo?.id,
            acronym,
            course_id: courseId,
            ...announcementdPayload,
          });

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: [{ type: 'AnnouncementsTag', id: 'LIST' }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAnnouncementsByCourseTeacherQuery, useAddAnnouncementMutation } =
  announcementTeacherApi;
